<mat-horizontal-stepper
  [linear]="false"
  #stepper
  (selectionChange)="onTabChange($event)"
>
  <mat-step *ngIf="data.uip_session_category_id != 4">
    <app-select-multi-vaccination-uip
      *ngIf="currentActiveStep == 'MULTIVACCUIP'"
      [activeStepIndex]="currentActiveStep"
      (onClose)="closeDialog()"
      (onStepChange)="onStepChange($event)"
    >
    </app-select-multi-vaccination-uip>
  </mat-step>
  <mat-step *ngIf="data.uip_session_category_id == 4">
    <app-hpv-vaccination
      *ngIf="currentActiveStep == 'MULTIVACCUIP'"
      [activeStepIndex]="currentActiveStep"
      (onClose)="closeDialog()"
      (onStepChange)="onStepChange($event)"
    >
    </app-hpv-vaccination>
    <!-- <app-generic-vaccination
      *ngIf="currentActiveStep == 'MULTIVACCUIP'"
      [activeStepIndex]="currentActiveStep"
      (onClose)="closeDialog()"
      (onStepChange)="onStepChange($event)"
    >
    </app-generic-vaccination> -->
  </mat-step>
  <mat-step>
    <app-vaccinate-member
      *ngIf="currentActiveStep == 'VACCINATEMEMBER'"
      [activeStepIndex]="currentActiveStep"
      (onClose)="closeDialog()"
      (onStepChange)="onStepChange($event)"
    >
    </app-vaccinate-member>
  </mat-step>
  <mat-step>
    <app-vaccinated-rejected-status
      *ngIf="currentActiveStep == 'VACCINATIONREJECTED'"
      [activeStepIndex]="currentActiveStep"
      (onClose)="closeDialog()"
      (onStepChange)="onStepChange($event)"
    >
    </app-vaccinated-rejected-status>
  </mat-step>
</mat-horizontal-stepper>
